import React from "react";
import { motion } from "framer-motion";
import { MousePointerClick, Truck, TrendingDown, Wallet, Megaphone, PackageCheck } from "lucide-react";
import ChapterHeading from "./ChapterHeading";
import { fadeUp, staggerParent, viewportOnce } from "../../lib/motion";

const services = [
  { icon: MousePointerClick, color: "#ED1C24", title: "Appro en un clic", line: "Commandez tout l'assortiment depuis une app simple." },
  { icon: Truck, color: "#68AD45", title: "Livraison rapide & fiable", line: "Depuis les hubs — moins de ruptures, moins de déplacements." },
  { icon: TrendingDown, color: "#524FA1", title: "Meilleurs prix", line: "La puissance d'achat du réseau fait baisser les coûts." },
  { icon: Wallet, color: "#231F20", title: "Crédit fournisseur", line: "Se réassortir sans avancer toute la trésorerie." },
  { icon: Megaphone, color: "#ED1C24", title: "Promotions ciblées", line: "Des offres nationales et par quartier." },
  { icon: PackageCheck, color: "#68AD45", title: "Point de collecte", line: "Retrait des commandes du quartier, du trafic en plus." },
];

export default function NosServices() {
  return (
    <section id="nos-services" data-testid="nos-services-section" className="relative bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-3xl">
          <ChapterHeading number="03" kicker="Nos services" title="Bien plus qu'une enseigne : des services." />
        </div>

        <motion.div
          variants={staggerParent}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5"
        >
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                variants={fadeUp}
                whileHover={{ y: -6 }}
                data-testid={`service-card-${s.title}`}
                className="group rounded-2xl border border-black/[0.04] bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-shadow duration-300 hover:shadow-[0_16px_50px_rgb(0,0,0,0.10)]"
              >
                <span
                  className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full transition-transform duration-300 group-hover:scale-110"
                  style={{ backgroundColor: `${s.color}15` }}
                >
                  <Icon size={28} color={s.color} strokeWidth={2.2} />
                </span>
                <h3 className="font-display font-bold text-xl text-diallo-charcoal">{s.title}</h3>
                <p className="mt-2 text-diallo-ink/70 leading-relaxed">{s.line}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
